import React from 'react';
import { Button } from 'drift-ui';
import styles from './ContinueButton.scss';

export const SimpleButton = ({ text, onClick }: { text: string; onClick?: () => void }) => {
  return (
    <Button className={styles.continueButton} onClick={onClick} variant="contained" size="large">
      {text}
    </Button>
  );
};

export default SimpleButton;
